var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_c('Loading')], 1) : _c('Form', {
    ref: "form",
    attrs: {
      "action": _vm.check
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var busy = _ref.busy;
        return [_vm.coverImage ? _c('div', {
          staticClass: "s-mb-2"
        }, [_c('img', {
          staticClass: "s-rounded-lg s-w-full",
          attrs: {
            "src": _vm.coverImage
          }
        })]) : _vm._e(), _c('h2', {
          staticClass: "s-text-xl s-text-gray-darker s-font-semibold s-mb-2"
        }, [_vm._v(_vm._s(_vm.product.title))]), _vm.groupBuying.type !== 3 && _vm.groupBuying.type !== 4 ? _c('div', [_c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("商品單價：")]), _c('dd', [_vm._v(_vm._s(_vm.spec.price) + " 元")])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("結單時間：")]), _c('dd', [_vm._v(_vm._s(_vm.endAt))])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("取貨方式：")]), _c('dd', [_vm._v(_vm._s(_vm.deliveryMethods))])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("付款方式：")]), _c('dd', [_vm._v("下單後立即付款")])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("出貨日期：")]), _c('dd', [_vm._v(_vm._s(_vm.groupBuying.delivery_shipping_day))])])]) : _c('div', [_c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("商品原價：")]), _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.original_price) + " 元")])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("商品售價：")]), _vm.groupBuying.groupbuying_sku.is_promotion ? _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.package_type))]) : _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.price) + " 元")])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("取貨方式：")]), _c('dd', [_vm._v("門市自取")])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("付款方式：")]), _c('dd', [_vm._v("下單後門市付款")])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', [_vm._v("取貨期限：")]), _c('dd', [_vm._v(_vm._s(_vm.branchEndAt))])])]), _c('div', {
          staticClass: "s-mb-2",
          style: {
            color: _vm.groupBuying.extra_message_color
          },
          domProps: {
            "innerHTML": _vm._s(_vm.groupBuying.extra_message)
          }
        }), _c('div', {
          staticClass: "s-pb-4 s-mb-4 s-border-b s-border-gray-lighter"
        }), _c('h3', {
          staticClass: "s-text-gray-darker s-font-semibold s-mb-2"
        }, [_vm._v("商品說明")]), _c('div', {
          staticClass: "s-mb-2",
          domProps: {
            "innerHTML": _vm._s(_vm.description)
          }
        }), _vm.productImages.length ? _c('div', {
          staticClass: "s-mb-2"
        }, _vm._l(_vm.productImages, function (image, i) {
          return _c('img', {
            key: i,
            staticClass: "s-w-full",
            attrs: {
              "src": image
            }
          });
        }), 0) : _vm._e(), _c('div', [(_vm.groupBuying.type == _vm.groupBuyingType3 || _vm.groupBuying.type == 4) && _vm.groupBuying.extra_images ? _vm._l(_vm.groupBuying.extra_images, function (image) {
          return _c('img', {
            key: image.url,
            staticClass: "s-w-full",
            attrs: {
              "src": image.url
            }
          });
        }) : _vm._e(), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', {
          staticClass: "s-whitespace-nowrap"
        }, [_vm._v("跟團群組：")]), _c('dd', [_vm._v(_vm._s(_vm.group.name))])]), _c('dl', {
          staticClass: "s-flex"
        }, [_c('dt', {
          staticClass: "s-whitespace-nowrap"
        }, [_vm._v("團購編號：")]), _c('dd', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_number))])])], 2), _c('div', {
          staticClass: "s-product-form"
        }, [_c('Counter', {
          staticClass: "s-mb-4",
          attrs: {
            "label": "下單數量",
            "name": "counter",
            "min": _vm.min,
            "max": _vm.max,
            "step": _vm.basis,
            "help": "\u4E0B\u55AE\u6578\u91CF\u6700\u591A ".concat(_vm.max, " \u500B\uFF0C\u6700\u5C11 ").concat(_vm.min, " \u500B"),
            "help-class": "s-text-danger",
            "disabled": _vm.isOutOfStock
          },
          model: {
            value: _vm.quantity,
            callback: function callback($$v) {
              _vm.quantity = $$v;
            },
            expression: "quantity"
          }
        }), _c('div', {
          staticClass: "s-flex s-items-center"
        }, [_c('dl', {
          staticClass: "s-flex-shrink-0 s-flex s-items-center s-mr-2"
        }, [_c('dt', {
          staticClass: "s-mr-2"
        }, [_vm._v("金額")]), _c('dd', {
          staticClass: "s-text-xl s-text-secondary s-price"
        }, [_vm._v("$ " + _vm._s(_vm.price))])]), _c('button', {
          staticClass: "s-btn s-btn-primary",
          attrs: {
            "type": "submit",
            "disabled": !_vm.product.id || busy || _vm.isOutOfStock
          }
        }, [_vm._v(" " + _vm._s(_vm.isOutOfStock ? '已售完' : '確定下單') + " ")])])], 1), _c('Modal', {
          ref: "confirm",
          attrs: {
            "title": "是否確認下單？"
          },
          scopedSlots: _vm._u([{
            key: "actions",
            fn: function fn(_ref2) {
              var close = _ref2.close;
              return [_c('div', {
                staticClass: "s-flex s-space-x-3"
              }, [_c('button', {
                staticClass: "s-btn s-btn-secondary",
                attrs: {
                  "type": "button"
                },
                on: {
                  "click": close
                }
              }, [_vm._v("取消")]), _c('button', {
                staticClass: "s-btn s-btn-primary",
                attrs: {
                  "type": "button"
                },
                on: {
                  "click": _vm.submit
                }
              }, [_vm._v("繼續下單")])])];
            }
          }], null, true)
        }, [_vm._v(" 提醒您，因您已有" + _vm._s(_vm.blacklistCount) + "次未取貨完成紀錄，"), _c('br'), _vm._v(" 如未在期限內完成取件，此帳號將暫停下單功能。 ")]), _c('Modal', {
          ref: "blocked",
          attrs: {
            "title": "無法下單"
          },
          scopedSlots: _vm._u([{
            key: "actions",
            fn: function fn(_ref3) {
              var close = _ref3.close;
              return [_c('div', {
                staticClass: "s-flex s-space-x-3"
              }, [_c('button', {
                staticClass: "s-btn s-btn-primary",
                attrs: {
                  "type": "button"
                },
                on: {
                  "click": close
                }
              }, [_vm._v("確認")])])];
            }
          }], null, true)
        }, [_vm._v(" 很抱歉！因此帳號已達4次未取貨紀錄，"), _c('br'), _vm._v(" 故已暫停下單功能。"), _c('br'), _c('br'), _vm._v(" 如有下單需求，請聯繫群組小編，謝謝！ ")])];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }